// Start of prototype spinner
// --------------------
// @author: Han Speerstra

spinner.fn = spinner.prototype;

/**
 * Initialize spinner
 * @param  {array} $new_config config array
 * @return {void}
 */
export default function spinner($new_config) {
	var that = this;

	this.config = $new_config;
	this.target = this.config.target;

	if(this.config.delay >= 0) {
	    this.delay = this.config.delay;
	}
	else {
    	this.delay = 500;
	}

	if(this.config.fade >= 0) {
	    this.fade = this.config.fade;
	}
	else {
		this.fade = 'normal';
	}

	if(this.config.fadeOut >= 0) {
	    this.fadeOut = this.config.fade;
	}
	else {
		this.fadeOut = 0;
	}
}

/**
 * Show the spinner
 * @return {void}
 */
spinner.fn.show = function()
{
	$(this.target).append('<div class="spinner-container" style="display:none;">' +
	 	'<div class="spinner">' +
	 	    '<div class="bounce1"></div>' +
	 	    '<div class="bounce2"></div>' +
	 	    '<div class="boucen3"></div>' +
		'</div>' +
	'</div>');
	$(this.target + ' .spinner-container').delay(this.delay).fadeIn(this.fade);
}

/**
 * Hide the spinner
 * @return {void}
 */
spinner.fn.hide = function()
{
    $(this.target + ' .spinner-container').fadeOut(this.fadeOut, function(){
    	$(this).remove();
    });
}

// --------------------
// End of prototype spinner
